export default class FieldValue extends Array {
  sum() {
    return this.reduce((acc, value) => acc + value)
  }

  count() {
    return this.length
  }

  max() {
    return this.reduce((max, value) => (value > max ? value : max))
  }

  min() {
    return this.reduce((min, value) => (value < min ? value : min))
  }
}